export default "__VITE_ASSET__BaPhOePt__"